'use client'

import { useEffect } from 'react'

import { logAmplitude } from '@/hooks/useAmplitude'

export function GuestTapOnTracker() {
  useEffect(() => {
    if (isTapOn(document.referrer)) {
      logAmplitude(`Guest tapped on`, { 'page.referrer': document.referrer })
    }
  }, [])

  return null // This component just tracks, doesn't render anything
}

const internalDomains = ['meandu.app', 'staging.meandu.app', 'mryum.local']

function isTapOn(referrer: string | undefined): boolean {
  // Condition 1: referrer is undefined or blank
  if (!referrer || referrer.trim() === '') {
    return true
  }

  try {
    const referrerUrl = new URL(referrer)
    const hostname = referrerUrl.hostname

    // Condition 2: does not come from internal domains
    const isInternalDomain = internalDomains.some(
      (domain) => hostname === domain || hostname.endsWith('.' + domain),
    )

    if (!isInternalDomain) {
      return true
    }

    // Check if the pathname ends with 'confirmation' or contains 'confirmation.tsx'
    const pathname = referrerUrl.pathname
    if (
      pathname.includes('confirmation') ||
      pathname.endsWith('/confirmation')
    ) {
      return true
    }
  } catch (error) {
    // If URL parsing fails, treat as invalid referrer (condition 1)
    return true
  }

  return false
}
